import { Controller } from 'stimulus'

const POLL_INTERVAL = 5000

// Polls for the event's game code and reveals the QR code once it exists.
// The joining instructions page renders in the portal layout, which does not
// load the `application` pack's global jQuery, so this fetches JSON and updates
// its own targets rather than eval'ing a server-rendered script like the older
// `game-code` controller does.
export default class extends Controller {
  static targets = ['qrCode', 'qrImage', 'code', 'loading']
  static values = {
    url: String,
    present: Boolean,
  }

  connect() {
    if (this.presentValue) return

    this.scheduleCheck()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  scheduleCheck() {
    this.timeout = setTimeout(() => this.check(), POLL_INTERVAL)
  }

  async check() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'application/json' },
      })

      if (!response.ok) return this.scheduleCheck()

      const { game_code: gameCode, qr_url: qrUrl } = await response.json()

      if (!gameCode) return this.scheduleCheck()

      this.reveal(gameCode, qrUrl)
    } catch (error) {
      this.scheduleCheck()
    }
  }

  reveal(gameCode, qrUrl) {
    if (this.hasQrImageTarget && qrUrl) this.qrImageTarget.src = qrUrl
    if (this.hasCodeTarget) this.codeTarget.textContent = gameCode
    if (this.hasQrCodeTarget) this.qrCodeTarget.classList.remove('hidden')
    if (this.hasLoadingTarget) this.loadingTarget.classList.add('hidden')

    this.presentValue = true
  }
}
